import React from "react"
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
const APP_PACIENTE_URL = `${process.env.REACT_APP_APP_PACIENTE_URL}` || "http://pac.sysdent.net"

const slugify = (text) => text.toString().toLowerCase().trim()
  .replace(/\s+/g, '-')
  .replace(/[^\w-]+/g, '')
  .replace(/--+/g, '-');

export function TokenPac({ token, onGetToken }) {
  const paciente = useSelector((state) => state.paciente);
  const empresa = useSelector((state) => state.empresa);

  // Use the stored slug if available, otherwise fallback to dynamic slugification
  const empresaSlug = empresa.slug || slugify(empresa.razonSocial || "clinica");
  const URL_PACIENTE = `${APP_PACIENTE_URL}/${empresaSlug}?token=${token}`

  function copyToClipboard() {
    navigator.clipboard.writeText(URL_PACIENTE).then(() => {
      alert("Copiado")
    }, (err) => {
      console.log('error', err)
    })
  }
  function whatsappButton() {
    return (
      <>
        <a
          href={`https://wa.me/51${paciente.telefono}?text=${URL_PACIENTE}`}
          target="_blank"
          className="show-on-hover__cta"
        >
          <WhatsAppIcon
            className="response-button__icon"
            style={{
              background: "#50CE56",
              height: "100%"
            }}
          />

        </a>
      </>
    )
  }

  return (<>

    <InputGroup className="mb-3">
      {!token && <Button variant="outline-secondary" onClick={onGetToken}>Invitar</Button>}
      {token && <Button variant="outline-secondary" onClick={copyToClipboard}>Copiar</Button>}
      <Form.Control aria-label="token" readOnly value={token} />
      {token && whatsappButton()}
    </InputGroup>


  </>
  )
}